import React from "react"
import { injectIntl } from "react-intl"
import { Header } from "../../common/headers"
import IntlProps from "../../state/helpers/IntlProps"
import { STOCK_DOCUMENTS_PAGE_MESSAGES } from "../../utils/inventory"
import { MainTabsComponent } from "../components"
import { DocumentTypesEditSection, DocumentTypesSelectionSection } from "../sections"

export const DocumentTypes = injectIntl((props: IntlProps) => {
    return (
        <>
            <MainTabsComponent/>
            <Header title={props.intl.formatMessage(STOCK_DOCUMENTS_PAGE_MESSAGES["header"])}/>
            <hr/>
            <DocumentTypesSelectionSection/>

            <DocumentTypesEditSection {...props}/>
        </>
    )
})


// WEBPACK FOOTER //
// ./src/inventory/pages/DocumentTypes.tsx